<template>
  <f7-page>
    <navbar :text="`${$t('Configuration.name')} > ${$t('Configuration.Tasks_Title')}`" />
    <div
      v-if="loaded"
      class="content-devx"
    >
      <f7-block>{{ $t('Configuration.Create_Task') }}</f7-block>
      <TaskDefinitionForm
        :activities="activities"
        :performance-units="performanceUnits"
        :current-task-definition="currentTaskDefinition"
      />
    </div>
    <f7-row v-if="loaded">
      <f7-col>
        <f7-button
          class="dx-btn-cancel margin-right"
          raised
          type="default"
          text-color="grey"
          styling-mode="outlined"
          @click="goToTasksDefinitions"
        >
          {{ $t("Go_Back") }}
        </f7-button>
      </f7-col>
      <f7-col>
        <f7-button
          class="dx-btn-success"
          raised
          type="success"
          styling-mode="contained"
          @click="createNewTask"
        >
          {{ $t("Button_save_text") }}
        </f7-button>
      </f7-col>
    </f7-row>
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import navbar from '../../../components/NavBar.vue';
import TaskDefinitionForm from '../../../components/configuration/tasks/taskDefinitionForm/index.vue';

export default {
  name: 'CreateTaskDefinition',
  components: {
    navbar,
    TaskDefinitionForm,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState('TaskDefinition', ['activities', 'performanceUnits', 'currentTaskDefinition']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.fetchActivities();
      await this.fetchPerformanceUnits();
      this.initStore();
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.loaded = true;
      this.$f7.preloader.hide();
    }
  },
  methods: {
    async createNewTask() {
      if (this.currentTaskDefinition.code === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.code_validation'));
      } else if (this.currentTaskDefinition.name === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.name_validation'));
      } else if (this.currentTaskDefinition.activityCode === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.activity_code_validation'));
      } else if (this.currentTaskDefinition.unit === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.unit_validation'));
      } else if (this.currentTaskDefinition.performanceUnit === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.unit_performance_validation'));
      } else if (this.currentTaskDefinition.price === '') {
        this.$f7.dialog.alert(this.$t('TaskDefinition.price_validation'));
      } else {
        try {
          const currentTaskDefinitionFormatted = {
            code: this.currentTaskDefinition.code,
            name: this.currentTaskDefinition.name,
            activity: this.getActivityNameByCode(this.currentTaskDefinition.activity_code),
            activity_code: this.currentTaskDefinition.activity_code,
            unit: this.currentTaskDefinition.unit,
            performance_unit: this.currentTaskDefinition.performance_unit,
            price: this.currentTaskDefinition.price,
            prescription: this.currentTaskDefinition.prescription,
            nursery: this.currentTaskDefinition.nursery,
          };
          await this.createTaskDefinition(currentTaskDefinitionFormatted);
          this.$f7.views.main.router.navigate('/viewTaskDetail/', { reloadCurrent: true });
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        }
      }
    },
    getActivityNameByCode(activityCode) {
      for (const activity of this.activities) {
        if (activity.code === activityCode) {
          return activity.name;
        }
      }
      return '';
    },
    goToTasksDefinitions() {
      this.initStore();
      this.$f7.views.main.router.navigate('/tasks/', { reloadCurrent: true });
    },
    ...mapActions('TaskDefinition', ['fetchActivities', 'fetchPerformanceUnits', 'createTaskDefinition', 'initStore']),
  },

};
</script>
